import palette from '~/config/theme/palette.mjs';

export const NAME = 'feed';

export const ADD_NEW_FEED_ITEMS = 'ADD_NEW_FEED_ITEMS';
export const DELETE_NEW_FEED_ITEM = 'DELETE_NEW_FEED_ITEM';
export const CLEAR_NEW_FEED_ITEMS = 'CLEAR_NEW_FEED_ITEMS';
export const ADD_FEED_ITEM_TO_UPDATE_LIST = 'ADD_FEED_ITEM_TO_UPDATE_LIST';
export const DELETE_FEED_ITEM_FROM_UPDATE_LIST = 'DELETE_FEED_ITEM_FROM_UPDATE_LIST';
export const ADD_FEED_ITEM_TO_DELETE_LIST = 'ADD_FEED_ITEM_TO_DELETE_LIST';
export const DELETE_FEED_ITEM_FROM_DELETE_LIST = 'DELETE_FEED_ITEM_FROM_DELETE_LIST';

export const FEED = {
  SUBSCRIPTIONS: [
    {
      collection: 'feed',
    },
  ],
};

export const FEED_ITEM_TYPES = {
  TRACES_MEMO: 'traces_memo',
  POST: 'post',
  DEPTH_COMMENTS: 'depth_comments',
  ALERT: 'alert',
  OPERATIONAL_NOTE: 'operational_note',
  OPERATION_SUMMARY: 'operation_summary',
  DAILY_COST: 'daily_cost',
  DOCUMENT: 'document',
  GENERIC_DATA_COMMENT: 'generic_data_comment',
  FLUID_REPORT: 'fluid_report',
  BHA: 'bha',
  SURVEY_STATION: 'survey_station',
  WELL_PLAN: 'well_plan',
  DRILLER_MEMO: 'driller_memo',
  NPT_EVENT: 'npt_event',
  LESSONS_LEARNED: 'lessons_learned',
  APP_ANNOTATION: 'app_annotation',
  GEOSTEERING_COMMENTS: 'geosteering_comments',
  HOOKLOAD_BROOMSTICK_COMMENT: 'hookload_broomstick_comment',
  DVD_COMMENT: 'dvd_comment',
  PC_COMMENT: 'pc_comment',
  DRILLING_DYSFUNCTION_EVENT: 'drilling_dysfunction_event',
  NPT_LESSONS_COMMENT: 'npt_lessons_comment',
  COMPLETION_OPERATIONAL_NOTE: 'completion_operational_note',
  COMPLETION_OPERATION_SUMMARY: 'completion_operation_summary',
  COMPLETION_DAILY_COST: 'completion_daily_cost',
  COMPLETION_DOCUMENT: 'completion_document',
  COMPLETION_ACTUAL_STAGE: 'completion_actual_stage',
  COMPLETION_NPT_EVENT: 'completion_npt_event',
};

export const FEED_ITEM_TIME_FORMAT = 'MM.DD.YYYY, HH:mm';

export const FEED_ITEM_CONFIGS = [
  {
    label: 'Post',
    category: 'post',
    type: FEED_ITEM_TYPES.POST,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Alert',
    category: 'post',
    type: FEED_ITEM_TYPES.ALERT,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Operational Note',
    category: 'post',
    type: FEED_ITEM_TYPES.OPERATIONAL_NOTE,
    segment: ['drilling'],
  },
  {
    label: 'Operation Summary',
    category: 'post',
    type: FEED_ITEM_TYPES.OPERATION_SUMMARY,
    segment: ['drilling'],
  },
  {
    label: 'Daily Cost',
    category: 'post',
    type: FEED_ITEM_TYPES.DAILY_COST,
    segment: ['drilling'],
  },
  { label: 'Document', category: 'post', type: FEED_ITEM_TYPES.DOCUMENT, segment: ['drilling'] },
  {
    label: 'Fluid Report',
    category: 'post',
    type: FEED_ITEM_TYPES.FLUID_REPORT,
    segment: ['drilling'],
  },
  { label: 'BHA', category: 'post', type: FEED_ITEM_TYPES.BHA, segment: ['drilling'] },
  {
    label: 'Survey Station',
    category: 'post',
    type: FEED_ITEM_TYPES.SURVEY_STATION,
    segment: ['drilling'],
  },
  // NOTE: Temporarily hidden on prod
  ...(process.env.REACT_APP_ENVIRONMENT !== 'production'
    ? [
        {
          label: 'Well Plan',
          category: 'post',
          type: FEED_ITEM_TYPES.WELL_PLAN,
          segment: ['drilling'],
        },
      ]
    : []),
  {
    label: 'Driller Memo',
    category: 'post',
    type: FEED_ITEM_TYPES.DRILLER_MEMO,
    segment: ['drilling'],
  },
  { label: 'NPT', category: 'post', type: FEED_ITEM_TYPES.NPT_EVENT, segment: ['drilling'] },
  {
    label: 'Lessons Learned',
    category: 'post',
    type: FEED_ITEM_TYPES.LESSONS_LEARNED,
    segment: ['drilling'],
  },

  {
    label: 'Operational Note',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_OPERATIONAL_NOTE,
    segment: ['completion'],
  },
  {
    label: 'Operation Summary',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_OPERATION_SUMMARY,
    segment: ['completion'],
  },
  {
    label: 'Daily Cost',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_DAILY_COST,
    segment: ['completion'],
  },
  {
    label: 'Document',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_DOCUMENT,
    segment: ['completion'],
  },
  {
    label: 'Stage Overview',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_ACTUAL_STAGE,
    segment: ['completion'],
  },
  // NOTE: Implement after Mo's explanation
  // { label: 'Stage Predictions', type: '???', segment: ['completion'] },
  {
    label: 'NPT',
    category: 'post',
    type: FEED_ITEM_TYPES.COMPLETION_NPT_EVENT,
    segment: ['completion'],
  },

  {
    label: 'App Annotation',
    category: 'post',
    type: FEED_ITEM_TYPES.APP_ANNOTATION,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Traces Memo',
    category: 'post',
    type: FEED_ITEM_TYPES.TRACES_MEMO,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Geosteering Recommendations',
    category: 'post',
    type: FEED_ITEM_TYPES.GEOSTEERING_COMMENTS,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Depth Comments',
    category: 'comment',
    type: FEED_ITEM_TYPES.DEPTH_COMMENTS,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Hookload Point Annotations',
    category: 'comment',
    type: FEED_ITEM_TYPES.HOOKLOAD_BROOMSTICK_COMMENT,
    showCreatorToLabel: true,
    segment: ['drilling'],
  },
  {
    label: 'DvD Comment',
    category: 'comment',
    type: FEED_ITEM_TYPES.DVD_COMMENT,
    showCreatorToLabel: true,
    segment: ['drilling'],
  },
  {
    label: 'Parameter Comparison',
    category: 'comment',
    type: FEED_ITEM_TYPES.PC_COMMENT,
    showCreatorToLabel: true,
    segment: ['drilling', 'completion'],
  },
  {
    label: 'Drilling Dysfunction',
    category: 'post',
    type: FEED_ITEM_TYPES.DRILLING_DYSFUNCTION_EVENT,
    showCreatorToLabel: true,
    segment: ['drilling'],
  },
  {
    label: 'Npt Lessons Comment',
    category: 'comment',
    type: FEED_ITEM_TYPES.NPT_LESSONS_COMMENT,
    showCreatorToLabel: true,
    segment: ['drilling'],
  },
  {
    label: 'Generic Data Comment',
    category: 'comment',
    type: FEED_ITEM_TYPES.GENERIC_DATA_COMMENT,
    showCreatorToLabel: true,
    segment: ['drilling', 'completion'],
  },
];

export const GENERIC_DATA_COMMENTS_VALUES_TYPES = {
  string: 'string',
  number: 'number',
  date: 'date',
  convertable: 'convertable',
};

export const FEED_ITEM_TYPES_BY_KEY = FEED_ITEM_CONFIGS.reduce(
  (result, feedItemType) => ({ ...result, [feedItemType.type]: feedItemType }),
  {}
);

export const SIDEBAR_FILTERS = {
  RIG_FILTERS: [
    { label: 'All', value: 'all' },
    { label: 'Filter by asset', value: 'filterByAsset' },
  ],

  DATE_RANGE_FILTERS: [
    // NOTE: Order matters in handleChangeDateRangeFilter and renderDateRangeFilters
    // { label: 'All', value: 'all' },
    { label: 'Last 24 hours', value: 'last24hours' },
    { label: 'Last 7 days', value: 'last7days' },
    { label: 'Custom', value: 'custom' },
  ],

  CONTENT_TYPE_FILTERS: FEED_ITEM_CONFIGS.map(feedItemType => ({
    label: feedItemType.label,
    value: feedItemType.type,
    segment: feedItemType.segment,
  })),

  USER_FILTERS: [
    { label: 'All', value: 'all' },
    { label: 'Filter by user', value: 'filterByUser' },
  ],
};

export const DEFAULT_CONTENT_TYPES_FILTER = FEED_ITEM_CONFIGS.reduce(
  (result, { type }) => [...result, type],
  []
);

export const IS_FEED_SHOWN = true;

export const MENTION_STYLE = {
  suggestions: {
    list: {
      background: palette.background.b9,
    },
    item: {
      color: 'white',
      height: 30,
      '&focused': {
        backgroundColor: 'rgba(255, 255, 255, 0.08)',
      },
    },
  },
};
